import { useEffect, useState } from "react";
import request from "project-config/services/request/request";
import useForm from "antd/es/form/hooks/useForm";
import type { FilterValue } from "antd/es/table/interface";
import { InoviceTabType } from "../constants";
import { useInvoiceStore } from "../store/invoice-store";

interface IInvoiceRecordInfo {
  total: number;
  pageSize: number;
  pageNum: number;
  items: {
    invoiceOrderNumber: string;
    createDate: string;
    type: number;
    money: number;
    status: number;
    expressNumber: string;
    remarks: string;
    cancelInvoice: string;
  }[];
}
interface IInvoiceRecordProps {
  startTime: [];
}
export function useInitRecordInfo() {
  const { currentInvoiceTab } = useInvoiceStore();
  const [invoiceRecordInfo, setInvoiceRecordInfo] =
    useState<IInvoiceRecordInfo>({
      total: 0,
      pageNum: 1,
      pageSize: 15,
      items: [],
    });
  const [invoiceRecordForm] = useForm<IInvoiceRecordProps>();
  const [currentFilter, setCurrentFilter] = useState<
    Record<string, FilterValue | null>
  >({});
  const fetchInvoiceRecord = async (pageNum?: number) => {
    const { data } = await request.post(
      "/api/rendering/user/queryInvoiceRecord",
      {
        pageSize: 15,
        pageNo: pageNum || 1,
        type: currentFilter.type === null ? undefined : currentFilter.type,
        status:
          currentFilter.status === null ? undefined : currentFilter.status,
        startTime: invoiceRecordForm.getFieldValue("startTime")
          ? new Date(invoiceRecordForm.getFieldValue("startTime")[0]).getTime()
          : undefined,
        endTime: invoiceRecordForm.getFieldValue("startTime")
          ? new Date(invoiceRecordForm.getFieldValue("startTime")[1]).getTime()
          : undefined,
      }
    );
    if (!data) return;
    setInvoiceRecordInfo(data);
  };

  useEffect(() => {
    if (currentInvoiceTab === InoviceTabType.BiilableRecord) {
      invoiceRecordForm.resetFields();
      return;
    }
    fetchInvoiceRecord(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentInvoiceTab, currentFilter]);

  return {
    setCurrentFilter,
    invoiceRecordForm,
    invoiceRecordInfo,
    setInvoiceRecordInfo,
    fetchInvoiceRecord,
  };
}
